"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_TOS_CONSENT = void 0;
const client_1 = require("@apollo/client");
exports.SEND_TOS_CONSENT = client_1.gql `
  mutation SendTosConsent($input: InputConsent!) {
    consent(input: $input)
  }
`;
